import { useQuery } from '@tanstack/react-query';
import { apiFetchProjectMemberships } from '../api';
import useProjectsContext from '../../projects/hooks/useProjectsContext';

export const useProjectMembership = (contactId: string) => {
  const { getProjectById } = useProjectsContext();

  const { data: projectMemberships, isLoading: isFetchingProjectMember } =
    useQuery({
      queryKey: ['projectMemberships', contactId],
      queryFn: () => apiFetchProjectMemberships(contactId),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    });

  const projectIds =
    projectMemberships?.data?.items
      .filter((projectMembership) => !projectMembership.data.isArchived)
      .map((item) => item.data.projectId) ?? [];

  const projects = projectIds
    .map((projectId) => getProjectById(projectId))
    .filter((project) => project)
    .filter(({ isArchived }) => !isArchived)
    .sort((a, b) => a.number.localeCompare(b.number));

  return {
    projects,
    isFetchingProjectMember,
  };
};
